import { DetailWithIcon } from "@/components/ResourceWithIcon.tsx";
import { OsIcon } from "@/modules/metal/os/OsIcon.tsx";
import { useMetalOs } from "@/modules/metal/os/useMetalOs.ts";

export function OsInfo({ os_id }: { os_id: string | null | undefined }) {
    const { title } = useMetalOs(os_id);

    return <DetailWithIcon title={title} icon={<OsIcon os_id={os_id} className="color-primary size-0.75rem" />} />;
}
